import { render } from "./TaskTable.vue?vue&type=template&id=a8f5a2a6&scoped=true"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"

import "./TaskTable.vue?vue&type=style&index=0&id=a8f5a2a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8f5a2a6"]])

export default __exports__